import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const LongTermCareNursingCareCoveragePercentage = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="LongTermCareNursingCareCoveragePercentage"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Nursing Care Coverage"
          decimalScale={2}
          rightIcon="far fa-percent"
          maxLength={14}
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
        />
      )}
    />
  );
};
